import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/:parkingId/role/:roleId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    parkingId: string;
    roleId: string;
}
const mutationFn = ({ parkingId, roleId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, roleId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, AxiosError<{ code: string; message: string }>> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteRole };
